import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const ABOUT_IMG = "/images/cecile.jpg";

const STATS = [
  { value: "15+", label: "years of teaching" },
  { value: "Paris", label: "native & francophone" },
  { value: "1 : 1", label: "private lessons only" },
];

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="cecile" ref={ref} className="py-24 lg:py-36" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <Reveal>
            <div className="absolute -bottom-4 -left-4 w-full h-full border border-gold pointer-events-none" aria-hidden="true" />
            <div className="relative overflow-hidden aspect-[4/5]" data-testid="about-image-frame">
              <motion.img
                src={ABOUT_IMG}
                alt="Cécile, founder of The French Atelier"
                style={{ y: imgY }}
                loading="lazy"
                className="w-full h-[115%] object-cover object-top"
                data-testid="about-image"
              />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>Your teacher</Eyebrow>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-6 leading-tight">
              Bonjour, I'm <span className="italic text-gold">Cécile.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-navy/70 leading-relaxed text-base sm:text-lg max-w-2xl" data-testid="about-bio">
              A Parisian by birth and a teacher by passion, I — Cécile Kinnunen —
              have been teaching French for over fifteen years. At The French Atelier,
              I welcome children, teens, adults, professionals and lifelong learners
              across the Houston area — or online, wherever you are.
            </p>
            <p className="mt-5 text-navy/70 leading-relaxed text-base sm:text-lg max-w-2xl">
              My conviction: you don't just learn a language, you live it. My lessons
              combine the rigor of a structured FLE method with the pleasure of
              conversation, culture and discovery.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-12 grid grid-cols-3 gap-6 border-t border-sand pt-8" data-testid="about-stats">
              {STATS.map((s) => (
                <div key={s.label}>
                  <p className="font-serif text-3xl lg:text-4xl text-gold">{s.value}</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-navy/60 mt-2">{s.label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
